/* eslint-disable max-len */
import React from 'react';
import { AllieIconProps } from '../../..';

export const FactoryGptMenuMobileApp = (props: AllieIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M12 19C16.8747 19 19 16.949 19 12C19 16.949 21.1104 19 26 19C21.1104 19 19 21.1104 19 26C19 21.1104 16.8747 19 12 19Z"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M6 10.5C9.13376 10.5 10.5 9.18153 10.5 6C10.5 9.18153 11.8567 10.5 15 10.5C11.8567 10.5 10.5 11.8567 10.5 15C10.5 11.8567 9.13376 10.5 6 10.5Z"
        stroke={props.color || '#51525C'}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};
